import { Observable, Subject } from 'rxjs';
import { finalize, last, mergeMap } from 'rxjs/operators';

export type ObservableQueue<R> = (factory: () => Observable<R>) => Observable<R>;

// TODO: Replace with request-animation-queue logic?
export function createObservableQueue<R>(): ObservableQueue<R> {
    let trigger: Subject<void>;
    return (factory: () => Observable<R>) => {
        if (!trigger || trigger.isStopped) {
            trigger = new Subject<void>();
            return createTriggeringObservable(factory, trigger);
        } else {
            const lastTrigger = trigger;
            const newTrigger = (trigger = new Subject<void>());
            return lastTrigger.pipe(
                last(),
                mergeMap(() => {
                    return createTriggeringObservable(factory, newTrigger);
                })
            );
        }
    };
}

function createTriggeringObservable<R>(
    factory: () => Observable<R>,
    trigger: Subject<void>
): Observable<R> {
    return factory().pipe(
        finalize(() => {
            trigger.next();
            trigger.complete();
        })
    );
}
